import 'Components/vm-slider/vm-slider';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-video-chapters.scss';

@customElement('vm-video-chapters')
export class VmVideoChapters extends LitElement {
    static override styles = Styles;

    @property({ type: Number, attribute: 'active-chapter-index' })
    activeChapterIndex = 0;

    override render() {
        return html`
            <div class="video-chapters-title">Topics in this Video</div>
            <vm-slider class="video-chapters-slider" .activeIndex="${this.activeChapterIndex}">
                <slot></slot>
            </vm-slider>
        `;
    }
}
